import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [CommonModule, HttpClientModule]
})
export class ApiModule {
  constructor() {}
}
